
/**
 * Custom element that displays size information for UK, US, or EU formats.
 * 
 * @class SizeDisplay
 * @extends HTMLElement
 * 
 * @example
 * <size-display data-size-active="uk" data-size-uk="UK 8" data-size-us="US 9"></size-display>
 */

let SIZES = ['uk', 'us', 'eu'];
const SIZE_STORAGE_KEY = 'size-display';
if (!customElements.get('size-display')) {
  customElements.define('size-display', class SizeDisplay extends HTMLElement {
    static get observedAttributes() {
      return [
        'data-size-active'
      ];
    }

    connectedCallback() {
      this.setAttribute('role', this.getAttribute('role') || 'text');
      this.setAttribute('aria-live', this.getAttribute('aria-live') || 'polite');
      this._render();
    }

    attributeChangedCallback() {
      this._render();
    }

    get active() {
      const fromStore = (localStorage.getItem(SIZE_STORAGE_KEY) || '').toLowerCase();
      const fromAttr = (this.getAttribute('data-size-active') || '').toLowerCase();
      return [fromStore, fromAttr, 'uk'].find(k => SIZES.includes(k)) || 'uk';
    }

    set active(val) {
      this.setAttribute('data-size-active', String(val).toLowerCase());
    }

    _getContentByKey(key) {
      return this.getAttribute(`data-size-${key}`) || '';
    }

    _render() {
      const key = this.active;
      let html = this._getContentByKey(key);

      if (!html) {
        const fallbacks = SIZES.filter(k => k !== key);
        for (const fb of fallbacks) {
          html = this._getContentByKey(fb);
          if (html) break;
        }
      }

      this.innerHTML = html;

      this.dispatchEvent(new CustomEvent('size-change', {
        detail: { active: key, html },
        bubbles: true
      }));
    }
  });
}

const updateAllSizeDisplays = (newSize, element) => {
  localStorage.setItem(SIZE_STORAGE_KEY, newSize);
  
  const productInfo = element.closest('product-info')
  if (productInfo) {
    productInfo.setAttribute('data-size-active', newSize);
  }

  document.querySelectorAll('size-display').forEach(el => {
    el.active = newSize;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const storedSize = (localStorage.getItem(SIZE_STORAGE_KEY) || 'uk').toLowerCase();
  if (SIZES.includes(storedSize)) {
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      productInfo.setAttribute('data-size-active', storedSize);
    }
  }
})